import { library, dom } from '@fortawesome/fontawesome-svg-core'
import {
    faArrowRight,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
    faCalendar,
    faBell,
    faMagnifyingGlass,
    faCheck,
    faThumbsUp,
    faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

import {
    faFacebookF,
    faInstagram,
    faLinkedin,
    faTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';

const icons = library.add(
    faArrowRight,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
    faBell,
    faMagnifyingGlass,
    faThumbsUp,
    faExclamationTriangle,
    faCheck,
    faFacebookF,
    faInstagram,
    faLinkedin,
    faTwitter,
    faYoutube,
    faCalendar,
);

dom.i2svg()
// dom.watch()
